import { Product, Program } from '@nemuru-eng/js-api-client';

import { LoanProduct } from '../types/LoanProduct';

export const programsByProductMap = (product: Product): Program[] => {
  switch (product) {
    case LoanProduct.AUTO_LOAN:
    case LoanProduct.CONSUMER_LOAN:
      return [Program.FREE_PROGRAM, Program.ZERO_PROGRAM];
    case LoanProduct.CREDIT_LINE:
      return [Program.NO_PURCHASE, Program.ZERO_PROGRAM, Program.FREE_PROGRAM];
    case LoanProduct.CARD:
      return [Program.NO_PURCHASE];
    default:
      return [];
  }
};
